import { QRCodeCanvas } from 'qrcode.react';
import { toast } from 'sonner';
import { Copy, Download, Send } from 'lucide-react';
import { Button } from './ui/button';

const baixarQR = (canvasId, arquivo) => {
  const canvas = document.getElementById(canvasId);
  if (!canvas) return;
  const hiRes = document.createElement('canvas');
  hiRes.width = 1024; hiRes.height = 1024;
  const ctx = hiRes.getContext('2d');
  ctx.imageSmoothingEnabled = false;
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, 1024, 1024);
  ctx.drawImage(canvas, 32, 32, 960, 960);
  const a = document.createElement('a');
  a.download = arquivo;
  a.href = hiRes.toDataURL('image/png');
  a.click();
  toast.success('QR Code baixado em alta resolução');
};

export const QuickLinkBlock = ({ link, titulo, descricao, mensagemWhatsapp, testid, destaque }) => (
  <div
    className={`rounded-2xl border p-4 ${destaque ? 'border-emerald-300 bg-emerald-50/50' : 'border-[#C5A059]/40 bg-white/70'}`}
    data-testid={`${testid}-block`}
  >
    <p className="text-sm font-bold text-[#0A2647]">{titulo}</p>
    <p className="text-xs text-slate-600 mt-0.5 mb-3 leading-relaxed">{descricao}</p>
    <div className="flex flex-col sm:flex-row gap-4 items-center">
      <div className="bg-white p-3 rounded-2xl border-2 border-[#C5A059]/30 shadow-inner flex-shrink-0" data-testid={`${testid}-qr-container`}>
        <QRCodeCanvas id={`${testid}-qr-canvas`} value={link} size={124} level="H" fgColor="#0A2647" bgColor="#FFFFFF" />
      </div>
      <div className="flex-1 w-full space-y-2.5">
        <p className="text-xs font-mono text-slate-700 break-all bg-white px-3 py-2 rounded-lg border border-slate-200" data-testid={`${testid}-value`}>{link}</p>
        <div className="flex gap-2 flex-wrap">
          <Button size="sm" className="bg-[#C5A059] hover:bg-[#b08e4a] text-white gap-1.5 text-xs h-9 px-4" data-testid={`${testid}-copy`}
            onClick={() => { navigator.clipboard.writeText(link); toast.success('Link copiado'); }}>
            <Copy className="w-3.5 h-3.5" /> Copiar link
          </Button>
          <Button size="sm" variant="outline" className="gap-1.5 text-xs h-9 px-4 border-emerald-300 text-emerald-700 hover:bg-emerald-50" data-testid={`${testid}-whatsapp`}
            onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(`${mensagemWhatsapp}\n\n${link}`)}`, '_blank')}>
            <Send className="w-3.5 h-3.5" /> Enviar no WhatsApp
          </Button>
          <Button size="sm" variant="outline" className="gap-1.5 text-xs h-9 px-4 border-[#0A2647]/30 text-[#0A2647] hover:bg-slate-50" data-testid={`${testid}-download-qr`}
            onClick={() => baixarQR(`${testid}-qr-canvas`, `${testid}.png`)}>
            <Download className="w-3.5 h-3.5" /> Baixar QR (PNG)
          </Button>
        </div>
      </div>
    </div>
  </div>
);
